// extracted by mini-css-extract-plugin
export default {"Card":"index__Card--vrNH7","card":"index__Card--vrNH7","CardHorizontal":"index__CardHorizontal--lMX1u","cardHorizontal":"index__CardHorizontal--lMX1u"};